import { render } from "./Tab1View.vue?vue&type=template&id=607993fb&scoped=true"
import script from "./Tab1View.vue?vue&type=script&lang=js"
export * from "./Tab1View.vue?vue&type=script&lang=js"

import "./Tab1View.vue?vue&type=style&index=0&id=607993fb&scoped=true&lang=css"

import exportComponent from "C:\\Deployment\\Member Portal\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-607993fb"]])

export default __exports__